<template>
	<SectionCard title="Coorti di riacquisto" icon="mdi-grid" subtitle="clienti per mese del primo ordine" no-padding data-tour="cohorts">
		<template #actions>
			<v-btn-toggle v-model="mode" mandatory dense color="primary">
				<v-btn x-small value="rate">% che ricompra</v-btn>
				<v-btn x-small value="spend">Spesa per cliente</v-btn>
			</v-btn-toggle>
		</template>
		<div v-if="loading" class="pa-6 text-center"><v-progress-circular indeterminate color="primary" size="24" /></div>
		<div v-else class="cc-scroll">
			<table class="cc-table">
				<thead>
					<tr>
						<th class="text-left">Primo ordine</th>
						<th class="text-right">Clienti</th>
						<th v-for="k in offsets" :key="k" class="text-right">{{ k === 0 ? 'Mese 0' : `+${k}` }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="c in cohorts" :key="c.month">
						<td class="text-no-wrap">{{ monthLabel(c.month) }}</td>
						<td class="text-right">{{ formatNumber(c.customers) }}</td>
						<td v-for="k in offsets" :key="k" class="text-right cc-cell" :style="cellStyle(c, k)">{{ cellText(c, k) }}</td>
					</tr>
					<tr v-if="!cohorts.length">
						<td :colspan="offsets.length + 2" class="text-center grey--text py-4">Nessun cliente nuovo nei mesi scelti</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="cc-note pa-3">
			Ogni riga sono i clienti al primo ordine in quel mese (filtro canale: canale del primo ordine). «+1» è il mese dopo: in «% che ricompra» la quota che ha ordinato in quel mese, in «Spesa per
			cliente» quanto hanno speso in media fino a quel mese. Mostra i 12 mesi fino a quello scelto sopra.
		</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber, formatPct, monthLabel } from '../format';

export default {
	name: 'CustomersCohorts',
	components: { SectionCard },
	props: {
		cohorts: { type: Array, default: () => [] },
		loading: { type: Boolean, default: false },
	},
	data() {
		return { mode: 'rate' };
	},
	computed: {
		offsets() {
			const max = Math.max(0, ...this.cohorts.map(c => c.cells.length - 1));
			return Array.from({ length: max + 1 }, (_, i) => i);
		},
		maxRate() {
			return Math.max(1, ...this.cohorts.flatMap(c => c.cells.filter(x => x.offset > 0).map(x => x.rate)));
		},
	},
	methods: {
		formatNumber,
		monthLabel,
		cell(c, k) {
			return c.cells.find(x => x.offset === k);
		},
		cellText(c, k) {
			const x = this.cell(c, k);
			if (!x) return '';
			return this.mode === 'rate' ? formatPct(x.rate) : formatEurCents(x.spendPerCustomer);
		},
		// colore piu' intenso dove ricompra di piu' (il mese 0 e' sempre 100%)
		cellStyle(c, k) {
			const x = this.cell(c, k);
			if (!x || k === 0 || this.mode !== 'rate') return {};
			const alpha = Math.min(0.85, 0.08 + (x.rate / this.maxRate) * 0.7);
			return { background: `rgba(25, 118, 210, ${alpha})`, color: alpha > 0.45 ? '#fff' : 'inherit' };
		},
	},
};
</script>

<style scoped>
.cc-scroll {
	overflow-x: auto;
}
.cc-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 13px;
}
.cc-table th,
.cc-table td {
	padding: 6px 10px;
	border-bottom: 1px solid #eef1f5;
	white-space: nowrap;
}
.cc-table th {
	font-size: 12px;
	color: #5f6b7a;
	font-weight: 500;
}
.cc-note {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
